import { render, staticRenderFns } from "./article_comment.vue?vue&type=template&id=f0e0b728&lang=pug"
import script from "./article_comment.vue?vue&type=script&lang=js"
export * from "./article_comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports